import React from 'react'
import css from '../nav.css'

export default function navbar() {
    return (
        <div id="navbar">
         Made with React
      </div>
    )
}
